import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import get from 'lodash/get';
import cn from 'classnames';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from '../../src/i18n';
import { getFilteredTourDates, getGroupedProductionsDateForTheCard } from '../../utils/common';
import { TP } from '../../constants/consts';
import TextButton from '../TextButton';
import { colors } from '../../constants/styleConstants';
import ProductionCardCollapsedContent from '../ProductionCardCollapsedContent';
import ExpandableListCard from '../ExpandableListCard';
import ProductionCommonInfo from '../EditComponents/EditProductionCardLayout/ProductionCommonInfo';
import ProductionDatesContent from '../ProductionDatesContent';

const useStyles = makeStyles(theme => ({
  content: {
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
  },
  wrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      justifyContent: 'flex-start',
    },
  },
  listingCard: {
    padding: '10px 22px',
  },
  btnWrapper: {
    justifyContent: 'flex-end',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center',
    },
  },
  btnSelect: {
    lineHeight: 1,
    fontSize: '12px',
    fontWeight: 'bold',
    color: colors.primary,
    minWidth: 84,
    padding: '6px 24px',
    border: `1px solid ${colors.primary}`,
  },
  titleCell: {
    maxWidth: '200px',
  },
  dates: {
    display: 'flex',
    flexWrap: 'wrap',
  },
}));

const ProductionListedCard = ({ production, className, children, onProductionSelect }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const cast = get(production, 'casts', []);
  const crew = get(production, 'crew', []);
  const other = get(production, 'other', []);
  const dates = get(production, 'dates', []);
  const existingTourDates = getFilteredTourDates(dates);
  const onSelect = () => {
    onProductionSelect(production);
  };
  const header = (
    <Grid container spacing={2} className={cn(classes.listingCard, className)}>
      <Grid container item sm={10} xs={12} md={10}>
        <ProductionCommonInfo production={production} withEmpty={false} />
        <ProductionDatesContent
          formattedDates={getGroupedProductionsDateForTheCard(production, false)}
          className={classes.dates}
        />
      </Grid>
      <Grid container item sm={2} xs={12} md={2} className={classes.btnWrapper}>
        {children || (
          <TextButton className={classes.btnSelect} onClick={onSelect}>
            {t(`${TP}.FN_SELECT`)}
          </TextButton>
        )}
      </Grid>
    </Grid>
  );

  const collapsedContent = (
    <ProductionCardCollapsedContent other={other} cast={cast} crew={crew} tourDates={existingTourDates} />
  );

  return <ExpandableListCard header={header} collapsedContent={collapsedContent} />;
};

ProductionListedCard.propTypes = {
  production: PropTypes.object.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default ProductionListedCard;
